import { Component,EventEmitter,Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BeneficiarioCriptomoneda } from 'src/app/dashboard/interfaces/beneficiario-criptomoneda.interface';
import { CuentaRetiro } from 'src/app/dashboard/interfaces/cuenta-retiro.interface';
import { TransaccionService } from 'src/app/dashboard/services/transaccion.service';
import { ErrorTypes } from 'src/app/shared/enums/error-types.enum';
import { TipoPago } from 'src/app/shared/enums/tipo-pago.enum';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-withdraw-summary-order',
  templateUrl: './withdraw-summary-order.component.html',
  styleUrls: ['./withdraw-summary-order.component.sass']
})
export class WithdrawSummaryOrderComponent {
  isSubmitting = false;

  constructor(
    private spinnerService: SpinnerService,
    private transaccionService: TransaccionService,
    private router: Router,
    private actionService: ActionsService
    ){}

  @Input()
  public montoRetiro: number = 0;

  @Input()
  public account: CuentaRetiro | undefined;

  @Input()
  public usuarioId: number | undefined;

  @Output()
  public goBack = new EventEmitter<any>();


  /**
   * 30/10/2026: la pantalla de retiro vuelve a consultar si el canal USDT
   * sigue abierto (Horario de Operaciones) justo antes de confirmar. Al entrar
   * ya se miraba, pero un cierre del operador con la pantalla abierta no
   * frenaba el retiro. Devuelve false si está cerrado; en ese caso ya avisó.
   */
  @Input()
  public verificarOperacion?: () => Promise<boolean>;

  async confirmarEnvio(){
    if (this.verificarOperacion && !(await this.verificarOperacion())) {
      return;
    }
    this.isSubmitting = true;
    const ref = this.spinnerService.start();

    const transaccionDTO ={
      "paisOrigen":'CL',
      "userId":this.usuarioId,
      "totalMonedaOrigen": +this.montoRetiro,
      "totalMonedaDestino":+this.montoRetiro,
      "monedaOrigen":'CLP',
      "monedaDestino":'CLP',
      "paisDestino":'CL',
      "formaPago":TipoPago.WALLET,
      "diferencia":null,
      "tasa": null,
      "beneficiarioCriptoId":null,
      "tasaCambioId":null,
      "valorCambioId":null,
      "tipoTransaccion": 'RETIRO',
      "cuentaRetiroId":this.account?.id,
    }
    try{
      const resultadoTransaccion = await this.transaccionService.saveTransaccion(transaccionDTO);
      this.spinnerService.stop(ref);
      Swal.fire({ title: 'Transacción creada', text: 'Se ha creado la transacción con éxito', icon: 'success', confirmButtonColor: '#1e5a3f' });
      this.router.navigate(['/wallet/home']);

    }catch(error: any){
      this.isSubmitting = false;
      this.spinnerService.stop(ref);
      Swal.fire({ title: 'Error al retirar dinero', text: 'Ha ocurrido un error al realizar la transferencia', icon: 'warning', confirmButtonColor: '#1e5a3f' }).then(()=>{
        this.router.navigate(['/wallet/client/withdraw']);
      });
    }
  }

  goToBack(): void {
    this.goBack.emit();
  }
}
